import { __awaiter, __generator } from "tslib";
export var createCheckoutExports = function (_a) {
    var context = _a.context;
    return ({
        createCheckout: function (productId, quantity, options, preOrderRequested) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, context.checkoutService.createCheckout(productId, quantity, options, preOrderRequested)];
            });
        }); },
    });
};
//# sourceMappingURL=exports.checkout.js.map